export default __webpack_public_path__ + "static/media/project5.c246febd.gif";